module.exports = __webpack_public_path__ + "static/img/footer_research.52d0a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer_research.png
// module id = mhe0
// module chunks = 1